import { CsvDetailsModal } from "#shared/view/components/CsvDetailsModal";
import { List } from "#shared/view/components/List";
import { Text } from "#shared/view/components/Text";

type Props = {
  opened: boolean;
  close: () => void;
};

export const MaterialsCsvDetailsModal = ({ close, opened }: Props) => {
  return (
    <CsvDetailsModal opened={opened} close={close}>
      <List>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {"id: "}
            </Text>
            {
              "ne pas remplir cette colonne si elle est vide. S'il existe déjà une valeur dans la colonne, ne pas la modifier.  Cet identifiant est interne à Fabera et permet de mettre à jour une ligne du fichier plutôt que d'en créer une nouvelle"
            }
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {"name: "}
            </Text>
            {"nom du consommable ou du matériaux qui sera affiché dans l'interface Fabera"}
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {"type: "}
            </Text>
            {"type du matériau. Les valeurs autorisées sont :"}
            <List withPadding>
              <List.Item>{"SHEET: Tôle"}</List.Item>
              <List.Item>{"ROUND_TUBE: Tube rond"}</List.Item>
              <List.Item>{"SQUARE_TUBE: Tube carré"}</List.Item>
              <List.Item>{"RECTANGULAR_TUBE: Tube rectangulaire"}</List.Item>
              <List.Item>{"ROUND_BAR: Barre ronde"}</List.Item>
              <List.Item>{"SQUARE_BAR: Barre carrée"}</List.Item>
              <List.Item>{"OTHER: Autre"}</List.Item>
            </List>
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {"subType: "}
            </Text>
            {
              "sous-type du matériau. Champ libre. Exemple dans le cas d'un Profilé : UPE, UPN, UAP, etc."
            }
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {"price: "}
            </Text>
            {
              "prix du consommable ou du matériaux en centimes. Exemple : 230 correspond à 230 centimes d'euros, donc à 2,30€"
            }
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {"width: "}
            </Text>
            {" largeur du matériau en mm"}
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {"length: "}
            </Text>
            {" longueur du matériau en mm"}
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {"height: "}
            </Text>
            {" hauteur du matériau en mm"}
          </Text>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {"grade: "}
            </Text>
            {" nuance du matériaux. Les valeurs autorisées sont :"}
          </Text>
          <List withPadding>
            <List.Item>{"STEEL_PRE_LACQUERED: Acier Prélaqué"}</List.Item>
            <List.Item>{"STEEL_COLD_ROLLED_CORTEN: Acier Corten (S355J0WP)"}</List.Item>
            <List.Item>{"STEEL_HOT_ROLLED_CORTEN: Corten Laminé à chaud"}</List.Item>
            <List.Item>{"STEEL: Acier"}</List.Item>
            <List.Item>{"GALVANIZED_STEEL: Acier galvanisé"}</List.Item>
            <List.Item>{"ALUMINIUM: Aluminium"}</List.Item>
            <List.Item>{"ZINC_ANTHRACITE: Zinc Anthracite"}</List.Item>
            <List.Item>{"ZINC: Zinc naturel"}</List.Item>
            <List.Item>{"ZINC_PATINATED: Zinc Patiné"}</List.Item>
            <List.Item>{"OTHER: Autre"}</List.Item>
          </List>
        </List.Item>
        <List.Item>
          <Text>
            <Text span fw={700}>
              {"density: "}
            </Text>
            {" densité du matériaux en kg/dm3"}
          </Text>
        </List.Item>
      </List>
    </CsvDetailsModal>
  );
};
